import {CenterContainer} from "@/components/common/CenterContainer";
import {Login} from "@/components/user/Login";
import {ThemeType} from "@/theming/baseTheme";
import {StyleSheet} from "react-native";
import {useCurrentTheme} from "@/theming/useCurrentTheme";
import {KeyboardAwareScrollView} from "react-native-keyboard-aware-scroll-view";
import OtpLoginFlow from "@/components/user/OtpLoginFlow";

export function LoginScreen() {
    const {theme} = useCurrentTheme();
    const styles = createStyles(theme);

    return (
        <KeyboardAwareScrollView
            style={{flex: 1}}
            contentContainerStyle={{flexGrow: 1}}
            enableOnAndroid={true}
        >
            <CenterContainer>
                <OtpLoginFlow style={styles.loginContainer} />
            </CenterContainer>
        </KeyboardAwareScrollView>
    );
}

const createStyles = (theme: ThemeType) => StyleSheet.create({
    loginContainer: {
        marginHorizontal: theme.spacing.md
    }
});
